import { GoToAccountSettingsCTA } from "./ctas";
export var EoriDetailsIA = function EoriDetailsIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2, context.brandOrder);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return WHAT_IS_EORI(strictLocalize);
    },
    getDescription: function getDescription() {
      return [EORI_DEFINITION(strictLocalize), NODE_ON_ORDERS_WITHOUT_EORI(strictLocalize)];
    }
  };
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return GoToAccountSettingsCTA(strictLocalize);
};
var WHAT_IS_EORI = function WHAT_IS_EORI(strictLocalize) {
  return strictLocalize({
    id: "JyA1NQ",
    defaultMessage: [{
      "type": 0,
      "value": "O que é um número EORI?"
    }]
  });
};
var EORI_DEFINITION = function EORI_DEFINITION(strictLocalize) {
  return strictLocalize({
    id: "VfEzWr",
    defaultMessage: [{
      "type": 0,
      "value": "O número de \"Registo e Identificação dos Operadores Económicos\" (com a sigla inglesa EORI) é um número único utilizado pelas empresas para se identificarem junto das autoridades aduaneiras nas declarações aduaneiras e outros documentos de importação. Pode adicionar ou atualizar o seu número EORI no seu perfil Faire na secção \"Informações fiscais e de importação\" na página \"Definições de conta\"."
    }]
  });
};
var NODE_ON_ORDERS_WITHOUT_EORI = function NODE_ON_ORDERS_WITHOUT_EORI(strictLocalize) {
  return strictLocalize({
    id: "g5oER+",
    defaultMessage: [{
      "type": 0,
      "value": "Observação: as encomendas sem um número EORI estão sujeitas a serem retidas na alfândega e podem ser devolvidas. Se não tiver um número EORI, pode candidatar-se a um no site do governo local. A inscrição é gratuita e demora apenas alguns minutos. Receberá o seu número EORI no prazo de 3 a 5 dias úteis."
    }]
  });
};